(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oq-sku-ean"] && !Shopify.designMode) return;
  try {
    // Přepnutí varianty → přepsat kód a EAN. Bez mapy (jednovariantní produkt)
  // se neděje nic, hodnoty vykreslil Liquid.
  (function () {
    'use strict';

    function apply(root) {
      var map;
      try {
        map = JSON.parse(root.getAttribute('data-oq-ids-map') || 'null');
      } catch (e) {
        return;
      }
      if (!map) return;

      var input = document.querySelector('input[name="id"], select[name="id"]');
      var entry = input && map[input.value];
      if (!entry) return;

      var pairs = [
        ['sku', entry.sku],
        ['ean', entry.ean],
      ];
      pairs.forEach(function (pair) {
        var wrap = root.querySelector('[data-oq-ids-' + pair[0] + ']');
        var value = root.querySelector('[data-oq-ids-' + pair[0] + '-value]');
        if (!wrap || !value) return;
        value.textContent = pair[1] || '';
        wrap.hidden = !pair[1];
      });

      var sep = root.querySelector('[data-oq-ids-sep]');
      if (sep) sep.hidden = !(entry.sku && entry.ean);
    }

    document.addEventListener('variant:update', function () {
      document.querySelectorAll('.oq-ids[data-oq-ids-map]').forEach(apply);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
